// extracted by mini-css-extract-plugin
export var cardHeader = "_kw-1";
export var contentCard = "_kw-0";
export var headerActions = "_kw-3";
export var reorderHandle = "_kw-5";
export var titleArea = "_kw-2";
export var titleAreaWithHandle = "_kw-4";